import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '@questlabs/react-sdk/dist/style.css';
import { GlobalLoader } from './components/ui/GlobalLoader';

// Lazy load the main layout
const Layout = lazy(() => import('./components/layout/Layout'));

// Lazy load pages
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Ecosystem = lazy(() => import('./pages/Ecosystem'));
const VentureDetail = lazy(() => import('./pages/VentureDetail'));
const Labs = lazy(() => import('./pages/Labs'));
const Ventures = lazy(() => import('./pages/Ventures'));
const Research = lazy(() => import('./pages/Research'));
const Contact = lazy(() => import('./pages/Contact'));

// Specific Ecosystem Venture Pages
const GrubDeli = lazy(() => import('./pages/ventures/GrubDeli'));
const AlbertaRank = lazy(() => import('./pages/ventures/AlbertaRank'));
const MedBookPro = lazy(() => import('./pages/ventures/MedBookPro'));
const GetDMFlow = lazy(() => import('./pages/ventures/GetDMFlow'));
const NordicCRM = lazy(() => import('./pages/ventures/NordicCRM'));
const AutoMarketPlaceCanada = lazy(() => import('./pages/ventures/AutoMarketPlaceCanada'));

function App() {
  return (
    <Router>
      <Suspense fallback={<GlobalLoader />}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="ecosystem" element={<Ecosystem />} />
            
            {/* Specific Venture Routes */}
            <Route path="ecosystem/grubdeli" element={<GrubDeli />} />
            <Route path="ecosystem/albertarank" element={<AlbertaRank />} />
            <Route path="ecosystem/medbookpro" element={<MedBookPro />} />
            <Route path="ecosystem/getdmflow" element={<GetDMFlow />} />
            <Route path="ecosystem/nordiccrm" element={<NordicCRM />} />
            <Route path="ecosystem/automarketplace-canada" element={<AutoMarketPlaceCanada />} />
            
            {/* Generic Catch-all for dynamic venture IDs */}
            <Route path="ecosystem/:id" element={<VentureDetail />} />
            
            <Route path="labs" element={<Labs />} />
            <Route path="ventures" element={<Ventures />} />
            <Route path="research" element={<Research />} />
            <Route path="contact" element={<Contact />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;